
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class JpmSecClassOverrideGrid extends SiteEntityGrid<JpmSecClassOverrideRow, any> {
        protected getColumnsKey() { return 'Data.JpmSecClassOverride'; }
        protected getDialogType() { return JpmSecClassOverrideDialog; }
        protected getIdProperty() { return JpmSecClassOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return JpmSecClassOverrideRow.localTextPrefix; }
        protected getService() { return JpmSecClassOverrideService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
        }
    }
}